import { BeneficiaryTransferDestination } from 'types/beneficiaries'
import { Currencies } from 'types/types'

export const WalletTransferType = {
  MAIN: 'MAIN',
  CUSTOMER: 'CUSTOMER',
} as const

export type WalletTransferType = (typeof WalletTransferType)[keyof typeof WalletTransferType]

export const PayoutInstructionTypes = {
  FIAT: 'FIAT',
  CRYPTO: 'CRYPTO',
  WALLET: 'WALLET',
}

export type PayoutInstructionType =
  (typeof PayoutInstructionTypes)[keyof typeof PayoutInstructionTypes]

interface Amount {
  value: string
  currency: string
}

interface PayoutInstruction {
  type: PayoutInstructionType
  // Wallet transfers
  beneficiaryWalletId?: string
  // BVNK Network transfers
  beneficiaryAccountReference?: string
  beneficiary?: Beneficiary
  paymentMethod?: string
}

interface Fee {
  value: number
  currency: string
}

interface Balance {
  value: string
  currency: string
}

export interface TransferRequest {
  walletId: string
  amount: Amount
  paymentReference: string
  instruction: PayoutInstruction
}

export interface TransferResponse {
  transactionReference: string
  fee: Fee
}

export interface TransferWalletsRequest {
  walletId: string
  currencyCode: string
  walletType: string
  customerReference: string
}

export interface TransferWalletsReponse {
  walletId: string
  name: string
  balance: Balance
  walletType: WalletTransferType
}

export interface Beneficiary {
  reference?: string
  details?: PayoutDetails
}

export interface IndividualDetails {
  firstName: string
  lastName: string
  dateOfBirth: string
}

export interface AddressDetails {
  country: string
}
export interface BankDetails {
  accountNumber: string
  code: string
  address: AddressDetails
}

export interface PayoutDetails {
  alias: string
  beneficiaryType: string
  transferDestination: BeneficiaryTransferDestination
  currency: Currencies
  individualDetails: IndividualDetails
  address: AddressDetails
  bankDetails: BankDetails
}
export interface PayoutRequest {
  walletId: string
  amount: Amount
  customerFee?: Amount
  paymentReference: string
  instruction: PayoutInstruction
  metadata?: Record<string, unknown>
}
export interface PayoutResponse {
  transactionReference: string
  fee: Fee
}

export interface CommonPayoutsForm {
  amount?: string
  challenge?: string
  currencyCode?: string
  password?: string
  paymentMethod?: string
  reference?: string
  transferDestination?: string
  walletId?: string
}
